import { GetArrayIndexByKeyValue } from '@ukpostbox/helpers';
import React from 'react';
import { CustomFolderEntry } from './CustomFolderEntry';
import { MapCustomFolderEntriesType } from './FolderEntriesTypes';

function MapCustomFolderEntries(props: MapCustomFolderEntriesType) {
	// eslint-disable-next-line react/jsx-no-useless-fragment
	if (!props.customFolderData) return <></>;

	return (
		// eslint-disable-next-line react/jsx-no-useless-fragment
		<>
			{props.customFolderData?.map((folder) => {
				if (folder.parentFolderId === props.mailBoxInfo.customFolderId) {
					return (
						<CustomFolderEntry
							folder={folder}
							gridView={props.gridView}
							handleFolderMoveCallback={(e) => props.handleFolderMoveCallback(e)}
						/>
					);
				}

				if (props.customFolderData && folder.parentFolderId && folder.id === props.mailBoxInfo.customFolderId) {
					const parentFolder =
						props.customFolderData[
							GetArrayIndexByKeyValue(props.customFolderData, 'id', folder.parentFolderId)
						];

					return (
						<CustomFolderEntry
							folder={folder}
							parentFolder={parentFolder}
							gridView={props.gridView}
							handleFolderMoveCallback={(e) => props.handleFolderMoveCallback(e)}
						/>
					);
				}

				// eslint-disable-next-line react/jsx-no-useless-fragment
				return <></>;
			})}
		</>
	);
}

export { MapCustomFolderEntries };
